export interface ICommand { }

export class AddProjectsToScenarioCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.AddProjectsToScenarioCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	Id: string
	ViewDefId: string
	KanbanStatusId: number | null

	constructor (workspaceId: number, portfolioId: string, id: string, viewDefId: string, kanbanStatusId: number | null)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
		this.ViewDefId = viewDefId
		this.KanbanStatusId = kanbanStatusId
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.AddProjectsToScenarioCommandV1, TCh.Domain.Quest'
	}

}

export class ApproveScenarioCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.ApproveScenarioCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	Id: string

	constructor (workspaceId: number, portfolioId: string, id: string)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.ApproveScenarioCommandV1, TCh.Domain.Quest'
	}

}

export class ApproveScenarioProjectCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.ApproveScenarioProjectCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	Id: string
	ProjectId: string

	constructor (workspaceId: number, portfolioId: string, id: string, projectId: string)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
		this.ProjectId = projectId
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.ApproveScenarioProjectCommandV1, TCh.Domain.Quest'
	}

}

export class ClonePortfolioScenarioCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.ClonePortfolioScenarioCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	SourceId: string
	Id: string
	CloneName: string

	constructor (workspaceId: number, portfolioId: string, sourceId: string, id: string, cloneName: string)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.SourceId = sourceId
		this.Id = id
		this.CloneName = cloneName
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.ClonePortfolioScenarioCommandV1, TCh.Domain.Quest'
	}

}

export class ConnectToCorporateScenarioCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.ConnectToCorporateScenarioCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	Id: string
	CorporateScenarioId: string

	constructor (workspaceId: number, portfolioId: string, id: string, corporateScenarioId: string)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
		this.CorporateScenarioId = corporateScenarioId
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.ConnectToCorporateScenarioCommandV1, TCh.Domain.Quest'
	}

}

export class CreatePortfolioScenarioCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.CreatePortfolioScenarioCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	CorporateScenarioId: string
	PortfolioId: string
	Id: string
	Name: string
	Description: string
	CriteriaHierarchyId: number | null
	WeightsSetId: number | null
	ApplyBenefitsConfidenceFactor: boolean
	Denomination: any
	ApprovalAcceptedStatusId: number | null
	ApprovalRejectedStatusId: number | null

	constructor (workspaceId: number, corporateScenarioId: string, portfolioId: string, id: string, name: string, description: string, criteriaHierarchyId: number | null, weightsSetId: number | null, applyBenefitsConfidenceFactor: boolean, denomination: any, approvalAcceptedStatusId: number | null, approvalRejectedStatusId: number | null)
	{
		this.WorkspaceId = workspaceId
		this.CorporateScenarioId = corporateScenarioId
		this.PortfolioId = portfolioId
		this.Id = id
		this.Name = name
		this.Description = description
		this.CriteriaHierarchyId = criteriaHierarchyId
		this.WeightsSetId = weightsSetId
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor
		this.Denomination = denomination
		this.ApprovalAcceptedStatusId = approvalAcceptedStatusId
		this.ApprovalRejectedStatusId = approvalRejectedStatusId
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.CreatePortfolioScenarioCommandV1, TCh.Domain.Quest'
	}

}

export class DeletePortfolioScenarioCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.DeletePortfolioScenarioCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	Id: string

	constructor (workspaceId: number, portfolioId: string, id: string)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.DeletePortfolioScenarioCommandV1, TCh.Domain.Quest'
	}

}

export class LockProjectScenarioAcceptanceCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.LockProjectScenarioAcceptanceCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	Id: string
	ProjectIds: any

	constructor (workspaceId: number, portfolioId: string, id: string, projectIds: any)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
		this.ProjectIds = projectIds
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.LockProjectScenarioAcceptanceCommandV1, TCh.Domain.Quest'
	}

}

export class LockProjectScenarioCommitmentDateCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.LockProjectScenarioCommitmentDateCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	Id: string
	ProjectIds: any

	constructor (workspaceId: number, portfolioId: string, id: string, projectIds: any)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
		this.ProjectIds = projectIds
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.LockProjectScenarioCommitmentDateCommandV1, TCh.Domain.Quest'
	}

}

export class LockProjectScenarioStartDateCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.LockProjectScenarioStartDateCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	Id: string
	ProjectIds: any

	constructor (workspaceId: number, portfolioId: string, id: string, projectIds: any)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
		this.ProjectIds = projectIds
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.LockProjectScenarioStartDateCommandV1, TCh.Domain.Quest'
	}

}

export class OptimizeSelectionCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.OptimizeSelectionCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	Id: string
	Resources: any
	TotalCost: number | null
	Opex: number | null
	Capex: number | null
	Othex: number | null
	Expenses: number | null
	OpexExpenses: number | null
	ApplyBenefitsConfidenceFactor: boolean

	constructor (workspaceId: number, portfolioId: string, id: string, resources: any, totalCost: number | null, opex: number | null, capex: number | null, othex: number | null, expenses: number | null, opexExpenses: number | null, applyBenefitsConfidenceFactor: boolean)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
		this.Resources = resources
		this.TotalCost = totalCost
		this.Opex = opex
		this.Capex = capex
		this.Othex = othex
		this.Expenses = expenses
		this.OpexExpenses = opexExpenses
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.OptimizeSelectionCommandV1, TCh.Domain.Quest'
	}

}

export class RemoveProjectsFromScenarioCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.RemoveProjectsFromScenarioCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	Id: string
	ProjectIds: any

	constructor (workspaceId: number, portfolioId: string, id: string, projectIds: any)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
		this.ProjectIds = projectIds
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.RemoveProjectsFromScenarioCommandV1, TCh.Domain.Quest'
	}

}

export class SaveReviewGridCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.SaveReviewGridCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	Id: string
	Grid: string

	constructor (workspaceId: number, portfolioId: string, id: string, grid: string)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
		this.Grid = grid
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.SaveReviewGridCommandV1, TCh.Domain.Quest'
	}

}

export class UnlockProjectScenarioAcceptanceCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.UnlockProjectScenarioAcceptanceCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	Id: string
	ProjectIds: any

	constructor (workspaceId: number, portfolioId: string, id: string, projectIds: any)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
		this.ProjectIds = projectIds
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.UnlockProjectScenarioAcceptanceCommandV1, TCh.Domain.Quest'
	}

}

export class UnlockProjectScenarioCommitmentDateCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.UnlockProjectScenarioCommitmentDateCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	Id: string
	ProjectIds: any

	constructor (workspaceId: number, portfolioId: string, id: string, projectIds: any)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
		this.ProjectIds = projectIds
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.UnlockProjectScenarioCommitmentDateCommandV1, TCh.Domain.Quest'
	}

}

export class UnlockProjectScenarioStartDateCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.UnlockProjectScenarioStartDateCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	Id: string
	ProjectIds: any

	constructor (workspaceId: number, portfolioId: string, id: string, projectIds: any)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
		this.ProjectIds = projectIds
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.UnlockProjectScenarioStartDateCommandV1, TCh.Domain.Quest'
	}

}

export class UpdatePortfolioScenarioCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdatePortfolioScenarioCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	CorporateScenarioId: string
	PortfolioId: string
	Id: string
	Name: string
	Description: string
	CriteriaHierarchyId: number | null
	WeightsSetId: number | null
	ApplyBenefitsConfidenceFactor: boolean
	Denomination: any
	ApprovalAcceptedStatusId: number | null
	ApprovalRejectedStatusId: number | null

	constructor (workspaceId: number, corporateScenarioId: string, portfolioId: string, id: string, name: string, description: string, criteriaHierarchyId: number | null, weightsSetId: number | null, applyBenefitsConfidenceFactor: boolean, denomination: any, approvalAcceptedStatusId: number | null, approvalRejectedStatusId: number | null)
	{
		this.WorkspaceId = workspaceId
		this.CorporateScenarioId = corporateScenarioId
		this.PortfolioId = portfolioId
		this.Id = id
		this.Name = name
		this.Description = description
		this.CriteriaHierarchyId = criteriaHierarchyId
		this.WeightsSetId = weightsSetId
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor
		this.Denomination = denomination
		this.ApprovalAcceptedStatusId = approvalAcceptedStatusId
		this.ApprovalRejectedStatusId = approvalRejectedStatusId
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdatePortfolioScenarioCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateProjectScenarioAcceptanceCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdateProjectScenarioAcceptanceCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	Id: string
	ProjectIds: any
	Acceptance: any

	constructor (workspaceId: number, portfolioId: string, id: string, projectIds: any, acceptance: any)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
		this.ProjectIds = projectIds
		this.Acceptance = acceptance
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdateProjectScenarioAcceptanceCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateProjectScenarioCommitmentDateCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdateProjectScenarioCommitmentDateCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	Id: string
	ProjectIds: any
	CommitmentDate: any | null

	constructor (workspaceId: number, portfolioId: string, id: string, projectIds: any, commitmentDate: any | null)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
		this.ProjectIds = projectIds
		this.CommitmentDate = commitmentDate
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdateProjectScenarioCommitmentDateCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateProjectScenarioMaxStartDateCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdateProjectScenarioMaxStartDateCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	Id: string
	ProjectIds: any
	MaxStartDate: any | null

	constructor (workspaceId: number, portfolioId: string, id: string, projectIds: any, maxStartDate: any | null)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
		this.ProjectIds = projectIds
		this.MaxStartDate = maxStartDate
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdateProjectScenarioMaxStartDateCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateProjectScenarioMinStartDateCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdateProjectScenarioMinStartDateCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	Id: string
	ProjectIds: any
	MinStartDate: any | null

	constructor (workspaceId: number, portfolioId: string, id: string, projectIds: any, minStartDate: any | null)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
		this.ProjectIds = projectIds
		this.MinStartDate = minStartDate
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdateProjectScenarioMinStartDateCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateProjectScenarioPlanLockCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdateProjectScenarioPlanLockCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	Id: string
	ProjectId: string
	LockedPlanId: string

	constructor (workspaceId: number, portfolioId: string, id: string, projectId: string, lockedPlanId: string)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
		this.ProjectId = projectId
		this.LockedPlanId = lockedPlanId
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdateProjectScenarioPlanLockCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateProjectScenarioStartDateCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdateProjectScenarioStartDateCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	Id: string
	ProjectIds: any
	StartDate: any | null

	constructor (workspaceId: number, portfolioId: string, id: string, projectIds: any, startDate: any | null)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
		this.ProjectIds = projectIds
		this.StartDate = startDate
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdateProjectScenarioStartDateCommandV1, TCh.Domain.Quest'
	}

}

export class UpdateScenarioAcceptancesCommandV1 implements ICommand {
	$type: string = 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdateScenarioAcceptancesCommandV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	Id: string
	Acceptances: any

	constructor (workspaceId: number, portfolioId: string, id: string, acceptances: any)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.Id = id
		this.Acceptances = acceptances
	}

	static matchType(cmd: any)	{
		return cmd.$type == 'TCh.Domain.Quest.PortfolioScenarios.Commands.UpdateScenarioAcceptancesCommandV1, TCh.Domain.Quest'
	}

}

